import { createApp } from "vue";
import { readJsonScript } from "./services/json";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import pinia from "./plugins/pinia";
import router from "./plugins/router";

const root = document.getElementById("vue-root");

if (root) {
  const globalProps = readJsonScript("vue-global-props", {});
  const pageProps = readJsonScript("vue-page-props", {});
  const page = root.dataset.page || "";

  const app = createApp(App, {
    page,
    globalProps,
    pageProps,
  });

  app.use(vuetify);
  app.use(pinia);
  app.use(router);
  app.mount(root);
}
